import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { setClassNames } from 'ddc-classnames-js';
import Address from 'wsm-contact-address';
import ResultsHeading from './ResultsHeading';
import { ResultsContext } from '../../contexts';

const AddressCard = ({
	name,
	address1,
	city,
	state,
	postalCode,
	getDirectionsLabel,
	getDirectionsUrl,
	addressClasses,
	label,
	ariaLabelledById
}) => {
	const optionalAttributes = {
		...(label && { 'aria-labelledby': ariaLabelledById })
	};
	const { handleLinkClick } = useContext(ResultsContext);
	const handleClick = () => {
		handleLinkClick('richContentLink', getDirectionsLabel, '');
	};
	const addressElementClasses = [
		...addressClasses.split(' '),
		'text-black',
		'ddc-font-size-base',
		'my-3'
	];

	return (
		<React.Fragment>
			{label && (
				<ResultsHeading
					label={label}
					ariaLabelledById={ariaLabelledById}
				/>
			)}
			<div
				{...optionalAttributes}
				className="bg-location bg-neutral-0 d-flex border p-4 mx-4 mb-4"
			>
				<div className="d-sm-inline mx-4">
					<i
						className="ddc-icon ddc-icon-map ddc-font-size-xlarge text-black"
						aria-hidden="true"
					/>
				</div>
				<Address
					name={name}
					address1={address1}
					city={city}
					state={state}
					postalCode={postalCode}
					url={{
						text: getDirectionsLabel,
						link: getDirectionsUrl
					}}
					addressClasses={setClassNames(addressElementClasses) || ''}
					onGetDirectionsClick={handleClick}
				/>
			</div>
		</React.Fragment>
	);
};
AddressCard.propTypes = {
	name: PropTypes.string.isRequired,
	address1: PropTypes.string.isRequired,
	city: PropTypes.string.isRequired,
	state: PropTypes.string.isRequired,
	postalCode: PropTypes.string.isRequired,
	getDirectionsLabel: PropTypes.string.isRequired,
	getDirectionsUrl: PropTypes.string.isRequired,
	addressClasses: PropTypes.string,
	label: PropTypes.string,
	ariaLabelledById: PropTypes.string
};
AddressCard.defaultProps = {
	label: '',
	ariaLabelledById: 'address-card-0',
	addressClasses: ''
};
export default AddressCard;
